// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.deptSelectCss > .q-tree > .q-tree__node > .q-tree__node-header:first-child > .q-tree__tickbox {\n  display: none;\n}\n", ""]);
// Exports
module.exports = exports;
